import * as React from 'react';

import { EntityActions, EntityType } from 'common/entity';

import { AppState } from 'common/models/AppState';
import { Datetime } from 'common/components/Datetime';
import { InfiniteList } from 'common/components/InfiniteList';
import { Loading } from 'common/components/Loading';
import { Money } from 'common/components/Money';
import { Product } from 'common/api/models/Product';
import { ProductApi } from 'common/api/resources/ProductApi';
import { RowActionButton } from 'common/components/RowActionButton';
import { MemberLink } from 'common/components/link/MemberLink';
import { toApiError } from 'common/utils/api';

interface ProductsTableProps {
  appState: AppState;
  entityActions: EntityActions;
  reloadAt: Date;
  onEdit: (Product: Product) => void;
}
interface ProductsTableState {
  products: Product[];
  isLoading: boolean;
  error?: string;
  next?: string;
}
export class ProductsTable extends React.Component<ProductsTableProps, ProductsTableState> {
  state: ProductsTableState = { products: [], isLoading: true };

  componentDidMount() {
    this.reload();
  }

  componentDidUpdate(prevProps: ProductsTableProps) {
    if (prevProps.reloadAt !== this.props.reloadAt) {
      this.reload();
    }
  }

  handleLoadMore = () => {
    this.reload(this.state.next);
  };

  reload(next?: string) {
    this.setState({ isLoading: true });

    ProductApi.getAllProducts({ from: next, limit: 20 }).then(
      res => {
        this.setState(s => ({
          products: s.next ? [...s.products, ...res.data] : res.data,
          next: res.next,
          isLoading: false,
        }));
        res.data.map(d => {
          this.props.entityActions.fetch(EntityType.MEMBER, d.updateId!);
        });
      },
      err => {
        this.setState({ error: toApiError(err), isLoading: false });
      }
    );
  }

  render() {
    const cols = 7;
    return (
      <div>
        {this.state.error && (
          <div className="alert alert-danger" style={{ marginTop: 20 }}>
            {this.state.error}
          </div>
        )}
        <InfiniteList hasMore={!!this.state.next} isLoading={this.state.isLoading} onLoadMore={this.handleLoadMore}>
          <div className="table-responsive">
            <table className="table table-striped table-hover" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Price</th>
                  <th>Updated</th>
                  <th>Updated By</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {this.state.isLoading && (
                  <tr>
                    <td colSpan={cols}>
                      <Loading />
                    </td>
                  </tr>
                )}
                {this.state.products.length === 0 && (
                  <tr>
                    <td colSpan={cols}>No results found.</td>
                  </tr>
                )}
                {this.state.products.map(
                  p =>
                    p.type !== Product.Type.WOOCOMMERCE && (
                      <tr key={p.id}>
                        <td>{p.sku}</td>
                        <td>{p.name}</td>
                        <td>
                          {p.type === Product.Type.DUES && 'Dues'}
                          {p.type === Product.Type.BADGE && 'Badge'}
                          {p.type === Product.Type.NORMAL && 'Normal'}
                          {p.type === Product.Type.LOCATIONS && 'Locations'}
                          {p.type === Product.Type.CERT_NEW && 'Cert New'}
                          {p.type === Product.Type.CERT_RENEW && 'Cert Renew'}
                          {p.type === Product.Type.WIKI && 'Wiki'}
                          {p.type === Product.Type.GLOBALCONNECT && 'Global Connect'}
                          {p.type === Product.Type.WOOCOMMERCE && 'WooCommerce'}
                        </td>
                        <td>
                          <Money value={p.price!} />
                        </td>
                        <td>
                          <Datetime at={p.updateAt} />
                        </td>
                        <td>
                          <MemberLink member={this.props.appState.entities.member[p.updateId!]} />
                        </td>
                        <td>
                          {p.type !== Product.Type.WOOCOMMERCE && (
                            <RowActionButton item={p} icon="pencil" onClick={this.props.onEdit} />
                          )}
                        </td>
                      </tr>
                    )
                )}
              </tbody>
            </table>
          </div>
        </InfiniteList>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Products/ProductsTable.tsx